exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.info-block {\n  border: 1px solid #efefef;\n  border-radius: 10px;\n  background: white; }\n.tag {\n  border-radius: 50%;\n  height: 15px;\n  width: 15px;\n  display: inline-block; }\n.tag-default {\n  background-color: gray; }\n.tag-success {\n  background-color: green; }\n.tag-warning {\n  background-color: orange; }\n.tag-danger {\n  background-color: red; }\n.mat-header-cell {\n  text-align: left; }\n.mat-table {\n  width: 100%; }\n.no-result-display {\n  padding: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-editor/vendor-upload/vendor-upload.component.scss
// module id = ../../../../../src/app/shared/components/offer-editor/vendor-upload/vendor-upload.component.scss
// module chunks = main